import { Button, Menu, MenuItem, QueryStateContent, Stack, Typography } from 'src/app/components'
import { WinnersModel } from 'src/app/modules/campaign/models/LuckyDraw.model'

import TabWinnerGrandPrize from './TabWinnerContent/TabWinnerGrandPrize'
import { LoadingIcon, XlsIcon } from 'src/app/components/Icons'
import TabWinnerConsolation from './TabWinnerContent/TabWinnerConsolationPrize'
import { useLuckyDrawDetailTabWinners } from './LuckyDrawDetailTabWinners.hook'
import { Refs } from 'src/app/utils/refs-utils'
import { twMerge } from 'tailwind-merge'
import { Theme } from 'src/app/components/Layouts/QueryState/QueryStateContent.theme'

export default function LuckyDrawDetailTabWinners() {

  const state = useLuckyDrawDetailTabWinners()
  const dataPrizeGrandPrize = state.grandPrizeList.data
  const dataPrizeConsolation = state.consolationList.data
  const grandPrizeNoData = !dataPrizeGrandPrize?.content || (dataPrizeGrandPrize?.content && dataPrizeGrandPrize?.content?.length < 1)
  const consolationNoData = !dataPrizeConsolation?.content || (dataPrizeConsolation?.content && dataPrizeConsolation?.content?.length < 1)

  const handleDownloadExport = async () => {
    const today = new Date();
    const formattedDate = today.toISOString().slice(0, 10).replace(/-/g, ''); // YYYYMMDD
    const name = `campaign_listwinners_${formattedDate}`;
    try {
      await state.exportWinners.download(`${name}.xlsx`, null);
      Refs.pageToast.show({
        severity: 'success',
        message: `${name} successfully exported (.xlsx).`
      });

    } catch (error) {
      console.log("🚀 ~ handleDownloadData ~ error:", error);
    }
  };

  if (state.grandPrizeList?.isFetching || state.grandPrizeList?.isLoading || state.consolationList?.isFetching || state.consolationList?.isLoading) {
    return (
      <QueryStateContent>
        <LoadingIcon />
        <Typography className={twMerge(Theme.description)}>
          Loading...
        </Typography>
      </QueryStateContent>
    );
  }

  if (state.grandPrizeList?.isError) {
    return errorFeedback(state.grandPrizeList as any)
  }

  if (state.grandPrizeList?.isError) {
    return errorFeedback(state.consolationList as any)
  }

  if (grandPrizeNoData && consolationNoData) {
    return <QueryStateContent title='No Data' description="The winner has not been determined yet."></QueryStateContent>
  }

  return (
    <div>
      <Stack
        direction="row"
        justify="between"
        items="center"
        className="pb-8"
      >
        <div className='text-2xl'>Grand Prize</div>
        <Menu
          closeOnClick={true}
          className="min-w-[160px]"
          menuButton={(
            <Button loading={state.exportWinners.isLoading} variant="outlined">
              Export Data
            </Button>
          )}
        >
          <MenuItem startIcon={XlsIcon} onClick={handleDownloadExport}>
            Export as XLS
          </MenuItem>
        </Menu>
      </Stack>
      {dataPrizeGrandPrize?.content?.map((item: WinnersModel) => {
        return (
          <Stack key={item.id} direction='col' className='gap-6'>
            <TabWinnerGrandPrize data={item} />
          </Stack>
        )
      })}
      <div className='py-8 text-2xl'>Consolation Prize</div>
      <TabWinnerConsolation data={dataPrizeConsolation?.content} />
    </div>
  )
}

const errorFeedback = (query: any) => {
  const errorMessage = query?.error?.response?.data?.response_schema?.response_message?.en ?? query?.error?.message;
  return (<QueryStateContent
    title="Error"
    description={errorMessage || "Interal server error"}
  >
    <Button onClick={() => query?.refetch()}>
      Reload
    </Button>
  </QueryStateContent>)
}